function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_44",
  "data-name": "Groupe 44",
  transform: "translate(0 17.494)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_43",
  "data-name": "Groupe 43"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_12",
  "data-name": "Trac\\xE9 12",
  d: "M32.713,288.389c-9.849,0-15.273,4.975-15.273,14.009a1.239,1.239,0,0,0,1.2,1.277H46.791a1.239,1.239,0,0,0,1.2-1.277C47.987,293.364,42.563,288.389,32.713,288.389ZM19.876,301.12c.471-6.754,4.783-10.176,12.837-10.176s12.367,3.422,12.838,10.176Z",
  transform: "translate(-17.44 -288.389)",
  fill: "#676767"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_46",
  "data-name": "Groupe 46",
  transform: "translate(6.8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_45",
  "data-name": "Groupe 45"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_13",
  "data-name": "Trac\\xE9 13",
  d: "M140.522,0a8.372,8.372,0,0,0-8.473,8.643c0,5.072,3.8,9.2,8.473,9.2S149,13.715,149,8.644A8.372,8.372,0,0,0,140.522,0Zm0,15.286c-3.264,0-5.919-2.98-5.919-6.642a5.808,5.808,0,0,1,5.919-6.089,5.873,5.873,0,0,1,5.918,6.089C146.441,12.306,143.786,15.286,140.522,15.286Z",
  transform: "translate(-132.049)",
  fill: "#676767"
})));

var SvgIcUser = function SvgIcUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_1_",
    "data-name": "user (1)",
    width: 30.547,
    height: 32.78,
    viewBox: "0 0 30.547 32.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_user.2e897992.svg";
export { ForwardRef as ReactComponent };